<template>
    <div class="m-schedules">
        <div class="swiper m-list" v-if="ready">
            <swiper ref="interSwiper" :options="swiperOptions">
                <swiper-slide
                 v-for="(item,index) in list" :key="index" :class="'state-' + item.state"                
                >
                    <div class="s-item">

                        <div class="head">
                            <div class="status">
                                <span v-if="item.state == 0">待开始</span>
                                <span v-if="item.state == 1">直播中</span>
                                <span v-if="item.state == 2">已结束</span>                        
                            </div>

                            <h5 class="time">{{ timeFormat(new Date(item.time),'mm-dd HH:MM') }}</h5>                              
                        </div>

                        
                        <div class="race-info">
                            <div class="team-logo">
                                <img :src="item.team1Logo">
                            </div>
                            <div class="score">
                                <div class="score-item" :class="{ 'winner' : item.team1Score > item.team2Score}">{{item.team1Score}}</div>
                                <div class="icon-dot">:</div>
                                <div class="score-item" :class="{ 'winner' : item.team1Score < item.team2Score}">{{item.team2Score}}</div>
                            </div>
                            <div class="team-logo">
                                <img :src="item.team2Logo">
                            </div>                       
                        </div>

                    
                    </div>
                </swiper-slide>                    
            </swiper>

            <!-- Add Arrows -->
            <div class="btn-next u-btn" @click='swiperNext' v-if="list.length > 4"></div>
            <div class="btn-prev u-btn" @click='swiperPrev' v-if="list.length > 4"></div>

        </div>

    </div>
</template>

<script>
export default {
    data (){

        return {
            list : [],
            ready : false,
            swiperOptions: {
                slidesPerView: 4,
                paginationClickable: true,
                spaceBetween: 25               
            },
            mid : 1,
            wid : 1,              
        }
    },
    computed: {
        swiper() {
            return this.$refs.interSwiper.swiper
        }
    },       
    created (){
        //this.render();

        // let max = this.mpl_list[0].id;
        // let max_index = 0;
        // for (let i = 0; i < this.mpl_list.length - 1; i++) {
        //     max_index = max < this.mpl_list[i+1].id ? (i+1) : max_index
        //     max = max < this.mpl_list[i+1].id ? this.mpl_list[i+1].id : max           
        // }

        let mid_filter = this.mpl_list.filter(function(e){
            return e.isDefault == true
        });

        this.mid = mid_filter ? mid_filter[0].id : this.mpl_list[0].id;

        //this.mid = max;

        let week_filter = this.week_list.filter(function(e){
            return e.current == true
        });

        this.wid = week_filter.length ? week_filter[0].id : this.week_list[0].id;        
    },
    props :{
        'active' : {
            default : false,
        },
        mpl_list : {
            default: () => [],
        },
        week_list : {
            default: () => [],
        },          
    },     
    watch : {
        active (val){
            if(val && !this.ready){
                this.render();       
            }
        },
    },      
    methods : {
        render (){
            let vm = this;
            this.$axios.get(this.$ajax_url_map.race_list,{
                params : {
                    mid : this.mid,
                }                   
            })
            .then(
                res => {
                    let pos = 0;
                    //console.log(res);                    
                    this.list = res.filter(function(e){
                        return e.mwId == vm.wid
                    });
                    //this.list = res;

                    for(var i=0;i<this.list.length;i++){
                        let ele = this.list[i];
                        if(ele.state == 1){
                            pos = i;
                            break;
                        }
                    }

                    this.ready = true;

                    setTimeout(function(){
                        vm.$refs.interSwiper.swiper.slideTo(pos)
                    },100)
                },
                rej => {

                }
            )
        },
        swiperNext() {
            this.$refs.interSwiper.swiper.slideNext()
        },
        swiperPrev() {
            this.$refs.interSwiper.swiper.slidePrev()
        },         
        timeFormat(date, fmt){
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;    
        },        
    },
}
</script>

<style scoped>

    .m-schedules{
        min-height: 192px;
    }

    .m-list{
        position: relative;
        /* display: flex; */
        padding: 0 65px;
    }

    .m-list .s-item{
        position: relative;
        width: 296px;
        height: 192px;
        background-color: #f0f0f0;
    }

    .s-item .head{
        position: relative;
        display: flex;
        height: 52px;
        line-height: 52px;
        padding: 0 15px;
        color: #ffffff;
        justify-content: space-between;
        background-image: url(~@/assets/images/sche/head-wait.png);
        overflow: hidden;
    }

    .m-list .state-1 .s-item{
        /* background-image: url(~@/assets/images/sche/bg-item_act.png); */
    }

    .m-list .state-2 .s-item{
        background-color: #d9d9d9;       
    }

    .state-1 .s-item .head{
        background-image: url(~@/assets/images/sche/head-live.png);
    }

    .state-1 .s-item .head::before{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 294px;
        height: 50px;
        margin-left: -147px;
        margin-top: -25px;
        background-image: url(~@/assets/images/sche/ani-live.png);
        background-repeat: repeat-x;
        animation: move_light .8s infinite;
    }

    .state-2 .s-item .head{
        background-image: url(~@/assets/images/sche/head-over.png);
    }
    
    @keyframes move_light {
       0%{
           transform: translateX(0);
           opacity: 1;
       }
       
       50%{
           transform: translateX(-30px);
           opacity: 0.5;
       }
       
       100%{
           transform: translateX(-60px);
           opacity: 1;
       }        
    }

    .time{
        position: relative;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
    }

    .status{
        position: relative;
        font-size: 20px;     
    }

    .race-info{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 34px;
    }

    .team-logo{
        margin: 0 10px;
    }

    .team-logo img{
        width: 48px;
        height: 48px;
    }

    .score{
        display: flex;
    }

    .icon-dot{
        width: 9px;
        height: 26px;
        margin: 17px 8px 0;
        font-size: 0;
        color: transparent;
        background-image: url(~@/assets/images/sche/icon-dot.png);
    }

    .score-item{
        width: 46px;
        height: 69px;
        margin: 0 4px;
        line-height: 69px;
        text-align: center;
        font-size: 56px;
        font-weight: 700;
        color: #ffffff;
        background-image: url(~@/assets/images/sche/bg-score.png);
    }
    
    .state-1 .score-item,
    .state-2 .score-item{
        color: #919191;
        background-image: url(~@/assets/images/sche/bg-score_2.png);
    }


    .score-item.winner{
        color: #fff;
    }

    /* .status{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 16px;
        color: #7cb1c9;
    }

    .state-1 .status{
        color: #ffc94c;
    } */

    .btn-prev{
        position: absolute;
        left: -70px;
        top: 50%;
        width: 39px;
        height: 53px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/video/btn-prev.png);
    }    

    .btn-next{
        position: absolute;
        right: -70px;
        top: 50%;
        width: 39px;
        height: 53px;
        transform: translateY(-50%);
        background-image: url(~@/assets/images/video/btn-next.png);
    }    
</style>


// WEBPACK FOOTER //
// src/components/page/schedules.vue